<canvas #pdfCanvas [hidden]="!loadComplete" class="backface-hidden" [ngClass]='loadComplete ? "d-block" : "d-none"'></canvas>
<div class="spinner-wrapper" *ngIf="!loadComplete">
  <fa-icon [icon]="['fas', 'spinner']" [pulse]="true" class="spinner mx-auto align-middle"></fa-icon>
</div>
